export default {
  'home.get-demo.bitton': '联系我们',
  'home.pay-video.bitton': '播放视频',
  'home.submit.button': '提交',
  'home.chowbuspos.title0': `Chowbus POS`,
  'home.chowbuspos.title1': '专为',
  'home.chowbuspos.title2': '亚洲餐厅',
  'home.chowbuspos.title3': '定制',
  'home.chowbuspos.desc': '新一代一体化POS可以每月帮您节省超过$8,000人工, 增长25%销售额.',
  'home.ecosystem.title': '整套生态系统，服务您的餐厅',
  'home.link.more': '了解详情',
  'home.rightporduct.spec.needs.title': '客制化方案满足不同餐厅的需求',
  'home.whychoosechowbus.title': '为什么选择Chowbus',
  'home.get-demo.form.title': '欢迎咨询销售顾问，获取产品介绍',
  'home.get-demo.form.subtitle': `请留下您的信息, 我们的销售顾问会在24小时内和您预约时间.`,
  'home.ourclients.title': '深受全美各种规模和菜系的餐厅信赖',

  'email.landingpage.get-demo.bitton': '联系我们',

  'rutech.robots.visit.button': '点击查看RuTech网站',
  'pricing.best.value.desc': '超值套餐!',
  'pricing.include.basic.package': '包含全部基础套餐服务',
  'pricing.include.basic.package.sub1': '云端餐饮管理系统',
  'pricing.include.basic.package.sub2': '售后客服',

  'blog.readmore.button': '更多',
  'home.chowbuspos.ecosystem.banner.title': '通过Chowbus POS推动业务增长',
  'home.chowbuspos.ecosystem.banner.points_of_sale': 'Chowbus POS',
  'home.chowbuspos.ecosystem.banner.pos_handheld': '手持POS',
  'home.chowbuspos.ecosystem.banner.tablet_ordering': '平板点餐',
  'home.chowbuspos.ecosystem.banner.qrcode_ordering': '二维码点餐',
  'home.chowbuspos.ecosystem.banner.kiosk': '智能自助点餐',
  'home.chowbuspos.ecosystem.banner.loyalty_restaurant': '餐厅专属会员系统',
  'home.chowbuspos.ecosystem.banner.online_ordering': '餐厅订餐网页',
  'home.chowbuspos.ecosystem.banner.third_party_integration': '第三方平台集成',
  'home.chowbuspos.ecosystem.banner.wait_list': '等位系统',

  'home.referral.form.title': '推荐餐厅的信息',
  'home.referral.form.subtitle.0': `请提供您的`,
  'home.referral.form.subtitle.1': `餐厅全名和详细地址*`,

  'home.referral.form.restaurant_origin': `您的全名和联系电话`,
  'home.referral.form.restaurant.your.fullName': `全名*`,
  'home.referral.form.restaurant.your.contact': `联系电话*`,
  'home.referral.form.restaurant_full_name': `餐厅全名*`,
  'home.referral.form.restaurant_address': `街，城市，州，邮编*`,
  'home.referral.form.referring_restaurant_business_label': `您想要推荐的餐厅名称是什么？`,
  'home.referral.form.referring_restaurant_business_name': `你要推荐的餐厅名称*`,
  'home.referral.form.referring_restaurant_address_label': `您想要推荐的餐厅详细地址是什么？`,
  'home.referral.form.referring_restaurant_address': `街，城市，州，邮编*`,
  'home.referral.form.referring_restaurant_maker_label': `被推荐餐厅的决策者的姓名是什么？`,
  'home.referral.form.referring_restaurant_maker_first_name': `名*`,
  'home.referral.form.referring_restaurant_maker_last_name': `姓*`,
  'home.referral.form.referring_restaurant_email_label': `被推荐餐厅的决策者的工作邮箱是什么？`,
  'home.referral.form.referring_restaurant_email': `example@example.com*`,
  'home.referral.form.referring_restaurant_mobile_label': `被推荐餐厅的决策者的手机号码是什么？`,
  'home.referral.form.referring_restaurant_mobile': `手机号码*`,
  'home.referral.form.referring_restaurant_mobile_not_required': `手机号码`,
  'home.referral.form.referring_restaurant_chowbus_sales_label': `如果有服务您的Chowbus销售代表或客户经理，请提供他们的名字和姓氏。`,
  'home.referral.form.referring_restaurant_chowbus_sales_first_name': `名`,
  'home.referral.form.referring_restaurant_chowbus_sales_last_name': `姓`,
  'home.referral.form.referring_restaurant_privacy_confirm_text': `提交此推荐表意味着您确认已获得被推荐人的同意，同意以此推荐表所提供的联系方式（包括电子邮件和电话）与其进行沟通。`,

  'home.referral.form.referring_restaurant_email_1': `电子邮件*`,
  'home.referral.form.referring_restaurant_business_name_1': `餐厅名称*`,
  'home.referral.form.restaurant_zip_1': `邮编*`,
  'home.pricingpage.get-demo.bitton': '获取专属报价',
  'home.referral.form.hearaboutchowbus': `您从哪个渠道获知的chowbus`,

  // 'home.book.pos.demo.button': `预约您的Chowbus POS Demo`,
  'home.book.pos.demo.button': `立即预约咨询`,
  'top.products.business.book.pos.demo.button': `现在联系`,
  'get-a-demo-from-privacy': `提交表单意味着您同意接收Chowbus短信`,
  'top.products.business.book.pos.demo.title': `立即预约免费咨询`,

  'home.why.chowbus.pos.showmorefeature.button': `展示更多功能`,
  'home.why.chowbus.pos.showlessfeature.button': `收起更多功能`,

  'home.blog.readmore.button': `阅读全文`,
  'home.blog.viewmore.button': `更多文章`,
  'home.blog.othersarticle': '其他文章',
  'home.blog.back': '返回',
  'home.blog.backbloghome': '返回',

  'home.chowbuspos.seechowbusworks': 'Chowbus如何帮助餐厅降本增效',
  'home.chowbuspos.slogan': '专为亚洲餐厅定制的POS解决方案',
  'home.chowbuspos.trusted_by_top_restaurants': 'Chowbus餐馆电脑已助力上千家餐厅降本增效',
  'home.chowbuspos.why_choose_chowbus': '他们选择Chowbus餐馆电脑的原因',

  'home.book.pos.referral.button': `解锁$500推荐礼金！`,
  'home.referral.form.referral_person_name': `您的姓名*`,
  'home.referral.form.referral_restaurant_name': `您的餐厅名称*`,
  'home.referral.form.referral_mobile': `您的联系电话*`,
  'home.referral.form.referral_restaurant_sale': `您的销售姓名`,
  'home.referral.form.recommend_restaurant_name': `推荐餐厅*`,
  'home.referral.form.recommend_restaurant_location': `推荐餐厅所在城市(City, State)*`,
  'home.referral.form.recommend_restaurant_contract_person_name': `推荐餐厅联系人*`,
  'home.referral.form.recommend_restaurant_contract_person_mobile': `推荐餐厅联系电话*`,
  'home.referral.form.field.required': '必填',
};
